import React, { useState, useRef, useEffect } from "react";
import { DeviceInfo } from "@/interface/deviceInfo";
import IconRight from "$/icons/icon-right.svg";
import styles from "./ContentDescription.module.scss";

interface ContentDescriptionProps {
  data: string;
  userAgent?: DeviceInfo;
}

const ContentDescriptionComponent: React.FC<ContentDescriptionProps> = ({ data, userAgent }) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const [isShowMoreBtn, setIsShowMoreBtn] = useState<boolean>(false);
  const descriptionRef = useRef(null);

  const handleShowMore = () => {
    setShowMore((prevState) => !prevState);
  };

  useEffect(() => {
    const element = descriptionRef?.current;

    if (element.offsetHeight < element.scrollHeight) {
      setIsShowMoreBtn(true);
    } else {
      setIsShowMoreBtn(false);
      setShowMore(true);
    }
  }, []);

  if (!data) return null;

  return (
    <>
      <div
        ref={descriptionRef}
        className={`${styles.detail} ${showMore ? styles.showAll : ""}`}
        dangerouslySetInnerHTML={{ __html: data }}
      />
      {isShowMoreBtn && (
        <button
          onClick={handleShowMore}
          type={"button"}
          className={`${styles.showMoreBtn} ${showMore ? styles.active : ""}`}
        >
          Show {showMore ? "Less" : "More"}
          <IconRight height={20} width={20} />
        </button>
      )}
    </>
  );
};

export default ContentDescriptionComponent;
